/* eslint-disable prettier/prettier */
import numbro from 'numbro'

export const titleText = (status) => {
  if (status === 'loading' || status === 'success') return 'Payment is Processing'
  if (status === 'Insufficient Funds') return 'Insufficient funds'
  if (status === 'cancelled') return 'This invoice has been cancelled by the supplier'
  if (status === 'fail') return 'Unsuccessful'
  if (status === 'Error') return 'Error'
  if (status === 'LogicalError') return 'There has been some error'
  if (status !== 'loading' && status !== 'success' && status !== 'Insufficient Funds' && status !== 'cancelled' && status !== 'fail' && status !== 'Error' && status !== 'LogicalError') return 'Please Try Again'
  return ''
}
  
export const subtitleText = (status, company_name, totalAmount) => {
  if (status === 'loading' || status === 'success') return `Your payment of $${numbro(totalAmount).format({ thousandSeparated: true, mantissa: 2 })} to ${company_name} is processing`
  if (status === 'Insufficient Funds') return 'Your account does not have sufficient funds'
  if (status === 'cancelled') return 'This invoice has been cancelled'
  if (status === 'fail') return 'This payment may not be successful, please check back later'
  if (status === 'Error') return 'There was some error'
  if (status === 'LogicalError') return 'There was some error'
  if (status !== 'loading' && status !== 'success' && status !== 'Insufficient Funds' && status !== 'cancelled' && status !== 'fail' && status !== 'Error' && status !== 'LogicalError') return 'System failure'
  return ''
}
  
export const buttonText = ({ status }) => {
  if (status === 'loading' || status === 'success') return 'Done'
  if (status === 'Insufficient Funds') return 'Change payment method'
  if (status === 'cancelled') return 'Go back to invoice'
  if (status === 'fail') return 'Show payment method'
  if (status !== 'loading' && status !== 'success' && status !== 'Insufficient Funds' && status !== 'cancelled' && status !== 'fail') return 'Go back and try again'
  return ''
}